module.exports = __webpack_public_path__ + "static/aigrette-b293ab5d16b5e4c230ac4b9b8e0a7c75.jpg";